import {
  FormField,
  FormItem,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { Control } from 'react-hook-form';

type SelectFields = 'contentPageVariant' | 'category';
type SelectContentObject = {
  name: string;
  value: string;
};

type FormSelectComponentProps = {
  formControl: Control<PlannerConfigEntityWithOptionalFields>;
  name: SelectFields;
  selectValuePlaceholder: string;
  selectContent: Array<SelectContentObject>;
  formDescription: string;
  disabled: boolean;
};

function FormSelectComponent({
  formControl,
  name,
  selectValuePlaceholder,
  selectContent,
  formDescription,
  disabled,
}: FormSelectComponentProps) {
  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Select
              {...field}
              onValueChange={field.onChange}
              defaultValue={field.value as string}
              disabled={disabled}
            >
              <SelectTrigger>
                <SelectValue placeholder={selectValuePlaceholder} />
              </SelectTrigger>
              <SelectContent>
                {selectContent.map((item) => (
                  <SelectItem key={item.name} value={item.value}>
                    {item.value}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormDescription>{formDescription}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default FormSelectComponent;
